export const PA_SAVE_DENIAL_CODE_MAP = 'paSaveDenialCodeMap';
export const PA_SEARCH_DENIAL_CODE_MAP = 'paSearchDenialCodeMap';
export const PA_GET_DENIAL_CODE_MAP = 'paGetDenialCodeMap';
export const PA_DELETE_DENIAL_CODE_MAP = 'paDeleteDenialCodeMap';



// WEBPACK FOOTER //
// ./src/store/denial-code-map/actions.type.js